import React from "react";
import { ReactFormGenerator } from "react-form-builder2";
import "react-form-builder2/dist/app.css";
import { Boxed } from "../../../components/Boxed.components";

const PreviewForm = ({ form }) => {
  return (
    <Boxed
      width="80%"
      margin="15px auto"
      bColor="#fff"
      borderRadius="4px"
      pad="16px"
      boxShadow="0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)"
    >
      <ReactFormGenerator
        form_action=""
        form_method="POST"
        data={form?.task_data ?? []}
        hide_actions={true}
      />
    </Boxed>
  );
};

export default PreviewForm;
